function isSafeUrl(value) {
    try {
        const url = new URL(value, window.location.origin);

        return ["http:", "https:"].includes(url.protocol);
    } catch (error) {
        return false;
    }
}

function isSafeColor(value) {
    return /^#(?:[0-9a-f]{3}|[0-9a-f]{6}|[0-9a-f]{8})$/i.test(value);
}

export default function stickyCta() {
    const cta = document.querySelector("[data-sticky-cta]");
    const link = cta?.querySelector("[data-sticky-cta-link]");
    const closeButton = cta?.querySelector("[data-sticky-cta-close]");

    if (!cta || !link) {
        return;
    }

    const label = cta.dataset.label?.trim();
    const url = cta.dataset.url?.trim();
    const color = cta.dataset.color?.trim();

    if (!label || !url || !isSafeUrl(url)) {
        return;
    }

    link.href = url;
    link.setAttribute("aria-label", label);

    if (color && color.toLowerCase() !== "#303cff" && isSafeColor(color)) {
        cta.style.setProperty("--gh-sticky-cta-color", color);
    }

    let dismissed = false;

    const updateVisibility = () => {
        if (!dismissed) {
            cta.hidden = window.scrollY < Math.max(280, window.innerHeight * 0.35);
        }
    };

    closeButton?.addEventListener("click", () => {
        dismissed = true;
        cta.hidden = true;
    });

    window.addEventListener("scroll", updateVisibility, {passive: true});
    updateVisibility();
}
